module.exports = __webpack_public_path__ + "img/info.dbc0120d.svg";